import React from 'react';
import { Navigation, Heart, Leaf, Sparkles, BookOpen } from 'lucide-react';
export function MethodSection() {
  // GPS Interior is now the center, with 4 other pillars around it
  const centerPillar = {
    title: 'GPS INTERIOR',
    text: 'Înveți să te observi fără critică. Oprești pilotul automat și instalezi prezența activă, claritate în emoții și decizii conștiente în fiecare zi.',
    icon: Navigation
  };
  const surroundingPillars = [{
    title: 'RESET EMOȚIONAL',
    text: 'Descoperi tiparele care te țin pe loc, înțelegi de unde vin și decizi să schimbi perspectiva, într-un spațiu sigur, ghidat și fără judecată.',
    icon: Heart,
    position: 'top'
  }, {
    title: 'TERAPII NATURALE',
    text: 'Primești intervenții psiho-medicale personalizate: uleiuri, plante, acupunctură, homeopatie, pentru susținerea echilibrului fizic și emoțional.',
    icon: Leaf,
    position: 'right'
  }, {
    title: 'RECONECTARE',
    text: 'Te întorci la corpul, bucuria și ritualurile tale zilnice. Reactivezi energia și resetezi sistemul nervos prin practici simple și plăceri reale.',
    icon: Sparkles,
    position: 'bottom'
  }, {
    title: 'JURNAL PSIHO-MEDICAL',
    text: 'Instrumentul tău zilnic de autocunoaștere, procesare și ancorare. Întrebări despre emoții, corp, nevoi și alegeri, fără suprasolicitare.',
    icon: BookOpen,
    position: 'left'
  }];
  return <section className="w-full bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-110">
      <div className="max-w-7xl mx-auto" data-id="element-111">
        <div className="text-center mb-16 max-w-3xl mx-auto" data-id="element-112">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-dark mb-6" data-id="element-113">
            PsihoMedicina: GPS-ul tău Interior
          </h2>
          <div className="w-16 h-0.5 bg-primary mx-auto mb-6" data-id="element-114"></div>
          <p className="text-lg text-body leading-relaxed" data-id="element-115">
            Procesul prin care înveți să îți citești corpul, să îți înțelegi
            emoțiile și să alegi conștient ce îți face bine, printr-un sistem
            integrat cu 5 elemente care lucrează împreună.
          </p>
        </div>

        {/* GPS Circle Layout - Desktop */}
        <div className="hidden lg:block relative mx-auto" style={{
        height: '900px',
        maxWidth: '1000px'
      }} data-id="element-116">
          {/* Center - GPS INTERIOR */}
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-20" data-id="element-117">
            <div className="bg-gradient-to-br from-primary to-medium rounded-2xl p-8 shadow-2xl text-white w-72 border-4 border-white" data-id="element-118">
              <div className="flex flex-col items-center text-center" data-id="element-119">
                <div className="w-16 h-16 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center mb-4" data-id="element-120">
                  <Navigation size={32} data-id="element-121" />
                </div>
                <h3 className="text-2xl font-bold mb-3" data-id="element-122">
                  {centerPillar.title}
                </h3>
                <p className="text-sm leading-relaxed text-white/90" data-id="element-123">
                  {centerPillar.text}
                </p>
              </div>
            </div>
          </div>

          {/* Top - Reset Emoțional */}
          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-64 z-10" data-id="element-124">
            <div className="bg-soft rounded-2xl p-6 shadow-lg text-center" data-id="element-125">
              <div className="w-12 h-12 rounded-full bg-primary text-white flex items-center justify-center mx-auto mb-3" data-id="element-126">
                <Heart size={24} data-id="element-127" />
              </div>
              <h3 className="text-lg font-bold text-dark mb-2" data-id="element-128">
                {surroundingPillars[0].title}
              </h3>
              <p className="text-sm text-body leading-relaxed" data-id="element-129">
                {surroundingPillars[0].text}
              </p>
            </div>
          </div>

          {/* Right - Terapii Naturale */}
          <div className="absolute top-1/2 right-8 transform -translate-y-1/2 w-64 z-10" data-id="element-130">
            <div className="bg-soft rounded-2xl p-6 shadow-lg" data-id="element-131">
              <div className="w-12 h-12 rounded-full bg-primary text-white flex items-center justify-center mx-auto mb-3" data-id="element-132">
                <Leaf size={24} data-id="element-133" />
              </div>
              <h3 className="text-lg font-bold text-dark mb-2 text-center" data-id="element-134">
                {surroundingPillars[1].title}
              </h3>
              <p className="text-sm text-body leading-relaxed text-center" data-id="element-135">
                {surroundingPillars[1].text}
              </p>
            </div>
          </div>

          {/* Bottom - Reconectare */}
          <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-64 z-10" data-id="element-136">
            <div className="bg-soft rounded-2xl p-6 shadow-lg text-center" data-id="element-137">
              <div className="w-12 h-12 rounded-full bg-primary text-white flex items-center justify-center mx-auto mb-3" data-id="element-138">
                <Sparkles size={24} data-id="element-139" />
              </div>
              <h3 className="text-lg font-bold text-dark mb-2" data-id="element-140">
                {surroundingPillars[2].title}
              </h3>
              <p className="text-sm text-body leading-relaxed" data-id="element-141">
                {surroundingPillars[2].text}
              </p>
            </div>
          </div>

          {/* Left - Jurnal Psiho-Medical */}
          <div className="absolute top-1/2 left-8 transform -translate-y-1/2 w-64 z-10" data-id="element-142">
            <div className="bg-soft rounded-2xl p-6 shadow-lg" data-id="element-143">
              <div className="w-12 h-12 rounded-full bg-primary text-white flex items-center justify-center mx-auto mb-3" data-id="element-144">
                <BookOpen size={24} data-id="element-145" />
              </div>
              <h3 className="text-lg font-bold text-dark mb-2 text-center" data-id="element-146">
                {surroundingPillars[3].title}
              </h3>
              <p className="text-sm text-body leading-relaxed text-center" data-id="element-147">
                {surroundingPillars[3].text}
              </p>
            </div>
          </div>

          {/* Connecting lines */}
          <svg className="absolute inset-0 w-full h-full pointer-events-none" style={{
          zIndex: 1
        }} data-id="element-148">
            <line x1="50%" y1="16%" x2="50%" y2="38%" stroke="#9B59A0" strokeWidth="2" strokeDasharray="5,5" opacity="0.4" data-id="element-149" />
            <line x1="70%" y1="50%" x2="62%" y2="50%" stroke="#9B59A0" strokeWidth="2" strokeDasharray="5,5" opacity="0.4" data-id="element-150" />
            <line x1="50%" y1="84%" x2="50%" y2="62%" stroke="#9B59A0" strokeWidth="2" strokeDasharray="5,5" opacity="0.4" data-id="element-151" />
            <line x1="30%" y1="50%" x2="38%" y2="50%" stroke="#9B59A0" strokeWidth="2" strokeDasharray="5,5" opacity="0.4" data-id="element-152" />
          </svg>
        </div>

        {/* Mobile Layout - Stack */}
        <div className="lg:hidden space-y-6" data-id="element-153">
          {/* Center GPS Interior Mobile */}
          <div className="bg-gradient-to-br from-primary to-medium rounded-2xl p-8 shadow-2xl text-white border-4 border-white" data-id="element-154">
            <div className="flex flex-col items-center text-center" data-id="element-155">
              <div className="w-16 h-16 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center mb-4" data-id="element-156">
                <Navigation size={32} data-id="element-157" />
              </div>
              <h3 className="text-2xl font-bold mb-3" data-id="element-158">{centerPillar.title}</h3>
              <p className="text-sm leading-relaxed text-white/90" data-id="element-159">
                {centerPillar.text}
              </p>
            </div>
          </div>

          {surroundingPillars.map((pillar, index) => {
          const Icon = pillar.icon;
          return <div key={index} className="bg-soft rounded-2xl p-6 shadow-lg" data-id="element-160">
                <div className="flex items-center space-x-4 mb-4" data-id="element-161">
                  <div className="w-12 h-12 rounded-full bg-primary text-white flex items-center justify-center shrink-0" data-id="element-162">
                    <Icon size={24} data-id="element-163" />
                  </div>
                  <h3 className="text-lg font-bold text-dark" data-id="element-164">
                    {pillar.title}
                  </h3>
                </div>
                <p className="text-body leading-relaxed" data-id="element-165">{pillar.text}</p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}